export default {
  direct: 'Direto',
  stops: 'escalas',
  stop: 'escala',
}
